/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useCallback, useMemo } from 'react';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import { Checkbox, FormGroup, Stack, styled } from '@mui/material';
import useInputs from 'hooks/useInputs';
import { Item } from 'interface/project/projectInfo';

const StyledFormControlLabel = styled(FormControlLabel)(({ theme }) => ({
  borderRadius: '4px',
  border: `solid 1px ${theme.palette.mind.grey.border2}`,
  backgroundColor: theme.palette.mind.custom.white,
  marginBottom: '10px',
  marginRight: 0,
  marginLeft: 0,
  '&:first-of-type': {
    marginTop: '10px',
  },
  color: theme.palette.mind.black.A0,
  '& .MuiFormControlLabel-label': {
    fontSize: 13,
    fontWeight: 400,
  },
}));
const StyledCheckbox = styled(Checkbox)(({ theme }) => ({
  color: theme.palette.mind.grey.border2,
}));

interface ISurveyMultiChoiceProps {
  id: string;
  items: Item[];
  type: string;
  handleNext: (_type: string, _surveyId: string, _info: any) => void;
  setIsDisabled: React.Dispatch<React.SetStateAction<boolean>>;
}
export interface IFormProps {
  id: string;
  value: boolean;
}
function SurveyMultiChoice({ id, items, type, handleNext, setIsDisabled }: ISurveyMultiChoiceProps): JSX.Element {
  const [form, setForm] = useInputs([]);

  useEffect(() => {
    setForm(
      items.map(obj => {
        return {
          id: obj.id,
          value: false,
        } as IFormProps;
      }),
    );
  }, [items, setForm]);

  const onChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      const { name, checked } = event.target;
      const nextForm = form.map((obj: any) => (obj.id === name ? { ...obj, value: checked } : obj));
      setForm(nextForm);
      const selected = nextForm.filter((obj: any) => obj.value).map((obj: any) => obj.id);
      handleNext(type, id, selected);
    },
    [form, handleNext, id, setForm, type],
  );

  const selected = useMemo(() => form.filter((obj: IFormProps) => obj.value === true) || [], [form]);
  useEffect(() => {
    setIsDisabled((selected?.length || 0) === 0);
  }, [selected?.length, setIsDisabled]);

  return (
    <Stack direction="column">
      <FormControl>
        <FormGroup>
          {items.map(obj => {
            return (
              <StyledFormControlLabel
                key={obj.id}
                control={
                  <StyledCheckbox
                    onChange={onChange}
                    name={obj.id}
                    checked={form.filter((_form: any) => _form.id === obj.id)[0]?.value ?? false}
                  />
                }
                label={obj.content}
              />
            );
          })}
        </FormGroup>
      </FormControl>
    </Stack>
  );
}

export default SurveyMultiChoice;
